import { Button, Container, Typography } from "@material-ui/core"
import styled from "styled-components"
import glass from "../../../../public/animation/glass.json"

import dynamic from "next/dynamic"

const Lottie = dynamic(() => import("lottie-react"), { ssr: false })

const StyledWrapper = styled(Container)`
  height: 100vh;
`

const StyledTitle = styled(Typography).attrs({ variant: "h1" })`
  font-size: 50px;
  margin-top: 35px;
  line-height: 0.8;
  color: #000;
`

const StyledText = styled(Typography).attrs({ variant: "body1" })`
  margin-top: 10px;
  line-height: 0.92;
  ${(p) => p.theme.breakpoints.down("sm")} {
    margin-top: 22px;
  }
`

const StyledButton = styled(Button).attrs({ variant: "contained" })`
  width: 158px;
  height: 48px;
  background-color: #ffb900;
  color: black;
  font-size: 24px;
  font-family: "NarkisBlock", sans-serif;
  margin-top: 40px;
`

const StyledLottie = styled(Lottie)`
  height: 50%;
`

const BlockedPayment = () => {
  return (
    <StyledWrapper>
      <StyledLottie animationData={glass} loop={false} />
      <StyledTitle>אופסי, משהו השתבש בדרך</StyledTitle>
      <StyledText>אם הבעיה ממשיכה אפשר לפנות לשירות לקוחות.</StyledText>
      <StyledButton
        onClick={() =>
          window.open("https://api.whatsapp.com/send?phone=972545738031")
        }
      >
        בואו ננסה שוב
      </StyledButton>
    </StyledWrapper>
  )
}

export default BlockedPayment
